import { render, staticRenderFns } from "./address-route-view.vue?vue&type=template&id=15d1c90d&"
import script from "./address-route-view.vue?vue&type=script&lang=js&"
export * from "./address-route-view.vue?vue&type=script&lang=js&"
import style0 from "./address-route-view.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports